import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();

    // Only add token for /api/private/** endpoints
    if (token && this.isPrivateApiRequest(request.url)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Expired or invalid token (tokens last 10 days): drop it and ask for a fresh login
        if (error.status === 401 && this.isPrivateApiRequest(request.url) && this.authService.hasToken()) {
          const returnUrl = this.router.url; // before logout() navigates away
          this.authService.logout();
          this.router.navigate(['/auth/login'], {queryParams: {returnUrl: AuthService.safeReturnUrl(returnUrl)}});
        }
        return throwError(error); // rxjs 6: takes the error itself, not a factory
      })
    );
  }

  private isPrivateApiRequest(url: string): boolean {
    return url.includes('/api/private/');
  }
}
